import {Button} from '@mui/material'
import DynamicTable from '../../../../reusable-components/tables/DynamicTable'
import TableButton from '../../../../reusable-components/tables/TableButton'
import TableSearchBar from '../../../../reusable-components/tables/TableSearchBar'
import TableTitle from '../../../../reusable-components/tables/TableTitle'
import TableWrapper from '../../../../reusable-components/tables/TableWrapper'
import {useEffect, useState} from 'react'
import AddBehaviourDialog from '../../../behaviour/component/AddBehaviour'
import axios from 'axios'
import { useSelector } from 'react-redux'
import { hasPermission } from '../../../../../_helper/hasPermission'
import { permissions } from '../../../../../_constants/permissions'
import { toast } from 'react-toastify'
import GeneralHeader from '../GeneralHeader'
const selectAuth = (state) => state.auth;

const REPLACEMENT_TABLE_HEADER = ['Name']

export const REPLACEMENT_DATA_MAPPING = {
  Name: 'name',
}
export const REPLACEMENT_SORTING = {
  Name: 'name',
}

export default function ReplacementBehaviour() {
  const [searchTerm, setSearchTerm] = useState('')
  const [addBehaviour, setAddBehviour] = useState(false)
  const [behaviour, setBehaviour] = useState('')
  const [data, setData] = useState([])
  const [isUpdate, setIsUpdate] = useState(false)
  const [bool, setBool] = useState(false)
  const [id, setId] = useState('')
  const [filteredData,setFilteredData] = useState([])
  const [queryData, setQueryData] = useState({
      pageNumber: 1,
      pageSize: 5,
      currentPage: 1,
      totalCounts: 1,
      sortBy: '_id',
      sortDir: 'desc',
      searchTerm: ''
  })
  const auth = useSelector(selectAuth);
  const userPermissions = auth.user.roleId;

  useEffect(() => {
    const getDate =async (page, pageSize, sortBy, sortDir)=>{
      const replacement = await axios.get(`/options?type=REPLACEMENT_BEHAVIOR&page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortDir=${sortDir}&searchTerm=${queryData?.searchTerm}`)
      const {data, currentPage, totalCounts} = replacement.data
      const replacementData = data?.map((item) => ({id: item._id, name: item.name}))
      setData(replacementData)
      setFilteredData(replacementData)
      setQueryData((prevState) => {
          return {
              ...prevState,
              currentPage,
              totalCounts,
          };
      });
    
  }
  getDate(queryData.pageNumber, queryData.pageSize, queryData.sortBy, queryData.sortDir)
  },[bool, queryData.pageNumber, queryData.pageSize, queryData.sortBy, queryData.sortDir, queryData?.searchTerm])

  const handleSubmit = async () => {
    try {
     const response = await axios.post('/options', {
        name: behaviour,
        type: 'REPLACEMENT_BEHAVIOR',
      })
      const { message, success } = response.data
      if(!success){
        return toast.error(message)
      }
      toast.success(message)
      handleClose()
      setBool(!bool)
    } catch (e) {
      console.error(e)
    }
  }

  const handleEdit = async () => {
    try {
     const response = await axios.put(`/options/${id}`, {
        name: behaviour,
      })
      const { message, success } = response.data
      if(!success){
        return toast.error(message)
      }
      toast.success(message)
      handleClose()
      setBool(!bool)
    } catch (e) {
      console.error(e)
    }
  }

  const handleUpdate = (e) => {
    setBehaviour(e.name)
    setAddBehviour(true)
    setIsUpdate(true)
    setId(e.id)
  }

  const handleClose = () => {
    setId('')
    setIsUpdate(false)
    setBehaviour('')
    setAddBehviour(false)
  }

  return (
    <>
    <GeneralHeader />
      <div className='card'>
        {addBehaviour ? (
          <AddBehaviourDialog
            setBehaviour={setBehaviour}
            behaviour={behaviour}
            handleClose={handleClose}
            handleSubmit={isUpdate ? handleEdit : handleSubmit}
            label='Add Replacement Behavior'
            title='Replacement Behavior'
          />
        ) : null}
        <div className='card-body'>
          <TableTitle title={'Replacement Behavior'}></TableTitle>
          <TableWrapper
            searchField={
              hasPermission(userPermissions, permissions.admin_billing_behavior_replacement_search) && 
                <TableSearchBar
                  label='Search'
                  variant='outlined'
                  size='small'
                  value={searchTerm}
                  setQueryData={setQueryData}
                  setSearchTerm={setSearchTerm}
                  margin='normal'
                  inputAdornmentPosition='start'
                />
            }
            tableButtons={
              hasPermission(userPermissions, permissions.admin_billing_behavior_replacement_create) && 
                <TableButton
                  variant='contained'
                  color='primary'
                  sx={{float: 'right', marginTop: '1.7rem'}}
                  onClick={(e) => {
                    setAddBehviour(true)
                  }}
                  title='Add New'
                />
            }
            dynamicTable={
              <DynamicTable
                columns={REPLACEMENT_TABLE_HEADER}
                data={filteredData}
                columnDataMapping={REPLACEMENT_DATA_MAPPING}
                sortingColumns={REPLACEMENT_SORTING}
                canUpdate={hasPermission(userPermissions, permissions.admin_billing_behavior_replacement_update)}
                onUpdate={handleUpdate}
                title={'Are you sure you want to discontinue those medication?'}
                setQueryData={setQueryData}
                queryData={queryData}
              />
            }
          />
        </div>
      </div>
    </>
  )
}
